import LegalLayout from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms & Conditions — LKTH LTD"
      description="The terms that apply when you use the LKTH LTD website and engage LKTH LTD for IT services."
      updated="January 2026"
      testid="terms-page"
    >
      <p>
        These terms govern your use of the LKTH LTD website and, together with any written
        quotation or statement of work, any services we provide to you. By using this website or
        engaging us, you agree to these terms.
      </p>

      <h2>1. About us</h2>
      <p>
        LKTH LTD is a company registered in England &amp; Wales with its registered office at Unit
        16 Park Village, Norfolk Park Road, Sheffield, South Yorkshire, S2 2UA, United Kingdom.
        Company registration number: [to follow].
      </p>

      <h2>2. Website content</h2>
      <p>
        The content of this website is for general information about our services. It does not
        constitute technical, legal or financial advice. While we keep the site accurate and up to
        date, content may change without notice, and example projects and testimonials shown are
        representative rather than guarantees of specific results.
      </p>

      <h2>3. Quotes and contracts</h2>
      <ul>
        <li>Quotes we provide are valid for 30 days unless stated otherwise.</li>
        <li>A contract for services is formed only when we both sign a statement of work or we confirm your acceptance in writing.</li>
        <li>Payment terms, milestones and deliverables are set out in your statement of work.</li>
      </ul>

      <h2>4. Your responsibilities</h2>
      <p>
        You agree to provide timely access to information, systems and decision-makers we reasonably
        need to deliver your project, and to ensure any content you supply does not infringe
        third-party rights.
      </p>

      <h2>5. Intellectual property</h2>
      <p>
        On full payment, you own the final website or application we deliver specifically for you.
        We retain ownership of pre-existing tools, libraries and know-how used to build it, and
        grant you a licence to use them as part of your deliverable. We may reference your project
        in our portfolio unless you ask us not to.
      </p>

      <h2>6. Liability</h2>
      <p>
        Nothing in these terms limits liability for death or personal injury caused by negligence,
        or for fraud. Subject to that, our total liability arising out of or in connection with our
        services is limited to the fees you paid us in the 12 months preceding the claim. We are
        not liable for indirect or consequential loss, including loss of profit or data caused by
        third-party services outside our control.
      </p>

      <h2>7. Service levels and support</h2>
      <p>
        Where you have a support agreement, response and resolution targets are those stated in your
        agreement. Support outside agreed hours may be charged at our published rates.
      </p>

      <h2>8. Governing law</h2>
      <p>
        These terms are governed by the laws of England &amp; Wales, and the courts of England
        &amp; Wales have exclusive jurisdiction over any dispute.
      </p>

      <h2>9. Contact</h2>
      <p>
        Questions about these terms: <a href="mailto:Lateshkatravath3366@gmail.com">Lateshkatravath3366@gmail.com</a> or 07383 390922.
      </p>
    </LegalLayout>
  );
}
